import React, { useEffect } from 'react'

const TeacherContent = ({ project, onUpdate }) => {
    useEffect(() => {}, [])

    return <></>
}

export default TeacherContent
